import React, { useState } from 'react'
import { ConfirmDialog } from 'primereact/confirmdialog';

interface OnConfirmDialogEntity {
    (isAccepted: boolean): void;
}

export default function DeleteConfirmationDialog({ isAccepted, isDeleteModel = true }: { isAccepted: OnConfirmDialogEntity, isDeleteModel?: boolean }) {

    const [visible, setVisible] = useState(false);

    const accept = () => {
        isAccepted(true);
    }

    return (
        <>
            <ConfirmDialog visible={(visible && isDeleteModel)} onHide={() => setVisible(false)} draggable={false} resizable={false} acceptClassName='p-button-danger'
                message="Do you want to delete this record?"
                header="Delete Confirmation" icon="pi pi-info-circle" accept={accept} />
            <img src="assets/images/delete-icon.svg" alt="Delete" onClick={() => setVisible(true)} />
        </>)
}
